import { transparentize } from 'polished';
import styled from 'styled-components';
import { Checkbox } from '../../Checkbox/Checkbox.js';
import { CheckboxIconUnchecked } from '../../Checkbox/CheckboxIcons.js';

var ContentCardCheckbox = styled(Checkbox).withConfig({
  displayName: "ContentCardCheckbox",
  componentId: "sc-1i98ofl-0"
})(["&&{", ";}"], function (props) {
  return !props.checked && "\n        box-shadow: 0px 0px 0px 1px ".concat(transparentize(0.6, props.theme.neutralColors.charcoal), ";\n        ").concat(CheckboxIconUnchecked, " {\n            border-color: ").concat(props.theme.neutralColors.white, ";\n        }\n    ");
});

export { ContentCardCheckbox };
